var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedStickerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 4,
    fill: "#8D5245"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0008 34.6998C18.3608 34.6998 13.8008 30.1398 13.8008 24.4998C13.8008 18.8598 18.3608 14.2998 24.0008 14.2998C29.6408 14.2998 34.2008 18.8598 34.2008 24.4998C34.2008 30.1398 29.6408 34.6998 24.0008 34.6998ZM24.0008 15.4998C19.0208 15.4998 15.0008 19.5198 15.0008 24.4998C15.0008 29.4798 19.0208 33.4998 24.0008 33.4998C28.9808 33.4998 33.0008 29.4798 33.0008 24.4998C33.0008 19.5198 28.9808 15.4998 24.0008 15.4998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8001 28.9405L17.5801 23.7205L18.4201 22.8805L22.8001 27.2605L29.5801 20.4805L30.4201 21.3205L22.8001 28.9405Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedStickerIcon);
export default __webpack_public_path__ + "static/media/checked-sticker-icon.e65bc4bc8ba8e9b437a826b0d84f75de.svg";
export { ForwardRef as ReactComponent };